import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner-native";

import { CoverageApi } from "@/data/api/coverageApi.ts";
import { useTranslator } from "@/hooks/useTranslate.ts";
import { queryClient } from "@/utils/queryClient";

import { HouseholdMembersQueryKeys } from "../queries/householdMembersQueries";

export const useCheckCoverageMutation = () => {
  const { t } = useTranslator();
  return useMutation({
    mutationFn: async ({ householdMemberId }: { householdMemberId: string }) =>
      CoverageApi.checkCoverage({ householdMemberId }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: HouseholdMembersQueryKeys.all,
      });
    },
    onError: () => {
      toast.error(t("common:errors.unknown"));
    },
  });
};
